module.exports = __webpack_public_path__ + "static/media/red-clear-X.cf9b87f5.svg";